import React, { useEffect, useState } from "react";
import { Modal, Spinner, Table, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { fetchWorkPackageHistoryById } from "../../../../store/features/workPackage/workPackageSlice";
import { IoDocumentTextOutline } from "react-icons/io5";
import ReactPaginate from "react-paginate";

const WorkPackageHistoryModal = ({
  selectedWorkPackage,
  showWorkPackageHistory,
  setShowWorkPackageHistory,
}) => {
  const { role } = useSelector((state) => state.auth);
  const [currentPage, setCurrentPage] = useState(0);
  const limit = 10;
  const { workPackageHistory, loading, wpHistoryPagination } = useSelector(
    (state) => state.workPackages
  );
  const dispatch = useDispatch();
  const { managers } = useSelector((state) => state.users);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  useEffect(() => {
    dispatch(
      fetchWorkPackageHistoryById({
        wpId: selectedWorkPackage.wpId,
        currentPage,
        limit,
      })
    );
  }, [currentPage]);
  const toggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <Modal
      size="lg"
      show={showWorkPackageHistory}
      onHide={() => setShowWorkPackageHistory(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{selectedWorkPackage.title} (Histroy)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <div className="table-wrapper">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Manager</th>
                      <th>WP Number</th>
                      <th>Person Months</th>
                      <th>Accepted</th>
                      {role !== "manager" && <th>Not Accepted Reason</th>}
                      <th>Start date</th>
                      <th>End date</th>
                      <th>Attchments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(role === "manager"
                      ? workPackageHistory.filter((w) => !w.rejectionReason)
                      : workPackageHistory
                    )?.map(({ history }) => {
                      const managerId = Array.isArray(history.managerIds)
                        ? history.managerIds?.[0]
                        : history.managerIds; // assuming only one manager
                      const managerName = managers?.find(
                        (m) => m._id === managerId
                      )?.name;

                      return (
                        <tr key={history._id}>
                          <td>
                            {history.title}{" "}
                            {history.approvalStatus === "pending" && (
                              <Badge bg="danger" style={{ fontSize: 9 }}>
                                New
                              </Badge>
                            )}
                            <p
                              style={{
                                fontSize: 12,
                                color: "#666",
                                fontWeight: 600,
                              }}
                            >
                              <small>{history.taskCount} Tasks</small>
                            </p>
                          </td>
                          <td>
                            {history.description?.length > 50 ? (
                              <>
                                {expandedDescriptions[history._id]
                                  ? history.description
                                  : `${history.description.slice(0, 50)}... `}
                                <span
                                  onClick={() => toggleDescription(history._id)}
                                  style={{ color: "blue", cursor: "pointer" }}
                                >
                                  {expandedDescriptions[history._id]
                                    ? "Show less"
                                    : "Show more"}
                                </span>
                              </>
                            ) : (
                              history.description
                            )}
                          </td>
                          <td>{managerName || "-"}</td>
                          <td>{history.wpNumber}</td>
                          <td>{history.personMonths}</td>
                          <td>
                            {history.approvalStatus !== null && (
                              <Badge
                                bg={
                                  history.approvalStatus === "Accepted"
                                    ? "success"
                                    : "danger"
                                }
                              >
                                {history?.approvalStatus}
                              </Badge>
                            )}
                          </td>
                          {role !== "manager" && (
                            <td>{history.rejectionReason}</td>
                          )}
                          <td>{history.startDate && format(history.startDate, "MM/dd/yyyy")}</td>
                          <td>{history.endDate && format(history.endDate, "MM/dd/yyyy")}</td>
                          <td>
                            {history.deliverables && (
                              <a
                                rel="noreferrer"
                                href={history.deliverables}
                                download={true}
                                target="_blank"
                              >
                                {" "}
                                <IoDocumentTextOutline size={"1.2rem"} />
                              </a>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                {wpHistoryPagination?.totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next >"
                      onPageChange={(e) => setCurrentPage(e.selected)}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={wpHistoryPagination.totalPages}
                      previousLabel="< Prev"
                      forcePage={currentPage}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};

export default WorkPackageHistoryModal;
